export const BUILD_INFO = {
  project: "CAT FARM",
  channel: "Internal Playtest",
  version: "0.1.0-alpha",
  id: "2026-10-08-01",
  date: "2026-10-08",
} as const;
